import {lazy, Suspense} from 'react'

import type {ChangeDetailsTabsProps} from './ChangeDetailsTabs.types'

const ChangeDetailsTabsLazy = lazy(
  () =>
    import(
      /* webpackChunkName: "ChangeDetailsTabs", webpackPrefetch: true */
      './ChangeDetailsTabs'
    ),
)

function ChangeDetailsTabs(props: ChangeDetailsTabsProps) {
  return (
    <Suspense fallback="">
      <ChangeDetailsTabsLazy {...props} />
    </Suspense>
  )
}

export default ChangeDetailsTabs
